import { createContext, useContext } from "react";
import type { Me } from "../api/types";

export const MeContext = createContext<Me | null>(null);
export function useMe() {
  return useContext(MeContext);
}
